export interface IDonationInitiative {
  initiativeId: number;
  initiativeName: string | null;
  active: boolean | null; // single character
  displayOrder: number | null;
}

export class DonationInitiative implements IDonationInitiative {
  initiativeId;
  id: number;
  initiativeName;
  active;
  displayOrder;

  constructor(config: IDonationInitiative) {
    this.initiativeId = config.initiativeId;
    this.id = config.initiativeId;
    this.initiativeName = config.initiativeName;
    this.active = config.active;
    this.displayOrder = config.displayOrder;
  }
}
